import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "../context/AuthContext";
import { formatError } from "../lib/api";

export default function AuthCallback() {
  const nav = useNavigate();
  const { googleSession } = useAuth();
  const [msg, setMsg] = useState("Procesando...");

  useEffect(() => {
    const hash = window.location.hash.replace(/^#/, "");
    const params = new URLSearchParams(hash);
    const sid = params.get("session_id");
    if (!sid) { setMsg("No session"); return; }
    (async () => {
      try {
        await googleSession(sid);
        toast.success("Bienvenido");
        nav("/app");
      } catch (e) {
        toast.error(formatError(e));
        nav("/login");
      }
    })();
    // eslint-disable-next-line
  }, []);

  return (
    <div className="min-h-screen flex items-center justify-center" data-testid="auth-callback">
      <div className="text-muted-foreground">{msg}</div>
    </div>
  );
}
